'use client'
import { FormEvoCallback } from '@repo/third-party-forms-components/FormEvoCallback'

const FormEvoCallbackPage = () => {
  return <FormEvoCallback />
}

export default FormEvoCallbackPage
